export default __webpack_public_path__ + "static/media/reactFooders.eea42104.png";